var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZeroLogs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_18_2139)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_18_2139)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2139)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2139",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12H12V36H36V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2704 21.1803C32.9804 20.7203 32.6704 20.2903 32.3504 19.8903C31.9804 19.4203 31.2804 19.3803 30.8604 19.8003L27.8604 22.8003C28.0804 23.4603 28.1204 24.2203 27.9204 25.0103C27.5704 26.4203 26.4304 27.5603 25.0204 27.9103C24.2304 28.1103 23.4704 28.0703 22.8104 27.8503C22.8104 27.8503 21.3804 29.2803 20.3504 30.3103C19.8504 30.8103 20.0104 31.6903 20.6804 31.9503C21.7504 32.3603 22.8604 32.5703 24.0004 32.5703C25.7804 32.5703 27.5104 32.0503 29.0904 31.0803C30.7004 30.0803 32.1504 28.6103 33.3204 26.7403C34.2704 25.2303 34.2204 22.6903 33.2704 21.1803Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0197 21.9806L21.9796 26.0206C21.4696 25.5006 21.1396 24.7806 21.1396 24.0006C21.1396 22.4306 22.4197 21.1406 23.9997 21.1406C24.7797 21.1406 25.4997 21.4706 26.0197 21.9806Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.25 17.7497L26.86 21.1397C26.13 20.3997 25.12 19.9597 24 19.9597C21.76 19.9597 19.96 21.7697 19.96 23.9997C19.96 25.1197 20.41 26.1297 21.14 26.8597L17.76 30.2497H17.75C16.64 29.3497 15.62 28.1997 14.75 26.8397C13.75 25.2697 13.75 22.7197 14.75 21.1497C15.91 19.3297 17.33 17.8997 18.91 16.9197C20.49 15.9597 22.22 15.4297 24 15.4297C26.23 15.4297 28.39 16.2497 30.25 17.7497Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8601 24.0001C26.8601 25.5701 25.5801 26.8601 24.0001 26.8601C23.9401 26.8601 23.8901 26.8601 23.8301 26.8401L26.8401 23.8301C26.8601 23.8901 26.8601 23.9401 26.8601 24.0001Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7699 14.2309C33.4699 13.9309 32.9799 13.9309 32.6799 14.2309L14.2299 32.6909C13.9299 32.9909 13.9299 33.4809 14.2299 33.7809C14.3799 33.9209 14.5699 34.0009 14.7699 34.0009C14.9699 34.0009 15.1599 33.9209 15.3099 33.7709L33.7699 15.3109C34.0799 15.0109 34.0799 14.5309 33.7699 14.2309Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2139",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2139",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZeroLogs);
export default __webpack_public_path__ + "static/media/icon-zero-logs.140e962f0c54b7f9e15d94e0962f2879.svg";
export { ForwardRef as ReactComponent };